<section class="materials">
  <div class="container">
    <div class="content">
      <div class="text-col">
        <span class="eyebrow">Our Expertise</span>
        <h2 class="title">The League City Yacht Sales Difference</h2>
        <p class="desc">
          Here at League City Yacht Sales, we travel across domestic and international markets to pursue yachts that
          define excellence focusing on the features that make the difference for your time on the water.
          <br /><br />
          Operating from our premier brokerage slips at Pier 27 at Watergate Marina Del Sol in Texas. We are your
          full-service
          maritime partners in the Southern United States and beyond.
          <br /><br />
          We pride ourselves in transparency and dedication to meet and exceed your yachting needs from the first
          walkthrough to the final handoff and everything in between. No matter where you are in the process, League
          City Yacht Sales is here for you every step of the way.
        </p>
      </div>

      <div class="image-col">
        <div class="grid-images">
          <div class="img-1">
            <img src="assets/images/home/materials/detail-1.jpg" alt="Detail 1" loading="lazy" />
          </div>
          <div class="img-2">
            <img src="assets/images/home/materials/detail-2.jpg" alt="Detail 2" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
